import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useQuery } from '@tanstack/react-query';
import { Flex } from '@amzn/storm-ui';
import { UserProfileApiResponse } from '../../interfaces/user/UserInterfaces';
import useApiClient from '../../services/api';
import { getUserProfile } from '../../services/user/userService';
import UserProfileDetailsSection from './components/UserProfileDetailsSection/UserProfileDetailsSection';
import { UserProfileEndpointQueryKey } from './services/endpoints';
import { Container, FlexContainer, AmazonLogo } from './TopNavigationHeader.styles';
import { useSyncCurrentUser } from '../../hooks/useSyncCurrentUser';
import { UserRoles } from '../../constants/userRoles';

export const TopNavigationHeader = () => {
  const { t } = useTranslation();
  const apiClient = useApiClient();
  const [isOpen, setIsOpen] = useState(false);

  const {
    data: userProfileData,
    // TODO Error response needs to be standardized.
  } = useQuery<UserProfileApiResponse, Error>({
    queryKey: [UserProfileEndpointQueryKey.USER_PROFILE],
    queryFn: () => getUserProfile(apiClient),
  });

  // Fallback to ACCOUNT_EXECUTIVE matches UserDetails.tsx behavior — the backend
  // always returns a role, so the fallback only guards against unexpected API gaps.
  useSyncCurrentUser(userProfileData?.user, UserRoles.ACCOUNT_EXECUTIVE);

  const handleProfileDisplay = () => setIsOpen(!isOpen);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Container>
        <FlexContainer>
          <Flex direction="row">
            <AmazonLogo
              src="https://m.media-amazon.com/images/G/31/AdSlot/adslot-logo._AC_SX400_FMpng_.png"
              alt="Amazon Adslot Logo"
            />
          </Flex>

          <UserProfileDetailsSection
            userProfileData={userProfileData}
            isOpen={isOpen}
            handleClose={handleClose}
            handleProfileDisplay={handleProfileDisplay}
          />
        </FlexContainer>
      </Container>
    </>
  );
};
